export default __webpack_public_path__ + "static/media/icon-info.529ad82f.svg";